export const getDestinationGreeting = (
  singularSalutation,
  pluralSalutation,
  travellerSalutation,
  travellerLastName,
  countryName,
) => {
  if (
    Object.keys(countrysWithArticleSingular).some((key) => key === countryName)
  ) {
    return `${countrysWithArticleSingular[countryName]} ${singularSalutation} ${travellerSalutation} ${travellerLastName}`;
  } else if (
    Object.keys(countrysWithArticlePlural).some((key) => key === countryName)
  ) {
    return `${countrysWithArticlePlural[countryName]} ${pluralSalutation} ${travellerSalutation} ${travellerLastName}`;
  } else {
    if (countryName) {
      return `${countryName} ${singularSalutation} ${travellerSalutation} ${travellerLastName}`;
    }
    return `Viel Freude bei Ihrer Reise ${travellerSalutation} ${travellerLastName}`;
  }
};

const countrysWithArticleSingular = {
  Schweiz: 'Die Schweiz',
  Tuerkei: 'Die Türkei',
};

const countrysWithArticlePlural = {
  'Griechische Inseln': 'Die Griechische Inseln',
  'Vereinigten Arabischen Emirate': 'Die Vereinigten Arabischen Emirate ',
  Niederlande: 'Die Niederlande',
  USA: 'Die USA',
};
